import React from 'react';

export const Footer = () => {
    return (
        <div className="text-center text-gray-500 py-8">
            &copy; {new Date().getFullYear()} TrueVote Pty Ltd
        </div>
    );
}